<section class="decision-summary" *ngIf="!loading && !error; else summaryState">
  <header class="decision-summary__header">
    <p class="decision-summary__eyebrow">{{ lang.translate('home.decisionSummary.eyebrow') }}</p>
    <h2 class="decision-summary__title">{{ lang.translate('home.decisionSummary.title') }}</h2>
  </header>

  <div class="decision-summary__grid">
    <button
      type="button"
      class="decision-summary__chip"
      *ngFor="let item of items"
      [class.decision-summary__chip--active]="activeState === item.state"
      [attr.data-state]="item.state"
      (click)="onSelect(item.state)"
    >
      <span class="decision-summary__chip-header">
        <span class="decision-summary__icon" aria-hidden="true">
          <i [class]="'fa ' + item.iconClass"></i>
        </span>
        <span class="decision-summary__label">{{ getLabel(item.state) }}</span>
      </span>
      <span class="decision-summary__count">{{ item.count }}</span>
    </button>
  </div>
</section>

<ng-template #summaryState>
  <div class="decision-summary decision-summary--state" *ngIf="error; else summaryLoading">
    <p class="decision-summary__state-copy">{{ error.message }}</p>
  </div>

  <ng-template #summaryLoading>
    <div class="decision-summary decision-summary--state" role="status">
      <p class="decision-summary__state-copy">{{ lang.translate('home.general.loading') }}</p>
    </div>
  </ng-template>
</ng-template>